import { useEffect } from "react";
import { initAnalytics } from "../firebase";
export default function Cookies({ consent, setConsent }) {
// Jeśli użytkownik zaakceptował, uruchamiamy Analytics
useEffect(() => {
if (consent === "accepted") {
    initAnalytics();
}
}, [consent]);

const acceptCookies = () => {
    localStorage.setItem("cookiesConsent", "accepted");
    setConsent("accepted");
};

const rejectCookies = () => {
    localStorage.setItem("cookiesConsent", "rejected");
    setConsent("rejected");
};

if (consent === "accepted" || consent === "rejected") return null;

return (
<div className="fixed bottom-4 left-1/2 transform -translate-x-1/2 z-50 w-full max-w-xl px-4">
    <div className="bg-white/90 backdrop-blur-md shadow-lg rounded-2xl p-4 flex flex-col md:flex-row items-center justify-between gap-3 text-sm md:text-base">
    <p className="text-gray-700">
        Ta strona korzysta z plików cookies w celu zapewnienia najlepszych wrażeń użytkownika.{" "}
        <span className={" font-semibold"}>
        Korzystając z niej, wyrażasz na to zgodę lub możesz odmówić.
        </span>
    </p>
    <div className="flex gap-2">
        <button
        onClick={rejectCookies}
        className="px-4 py-2 text-black bg-gray-300 hover:bg-gray-400 rounded-lg transition"
        >
        Odrzuć
        </button>
        <button
        onClick={acceptCookies}
        className="px-4 py-2 text-white bg-black hover:bg-gray-800 rounded-lg transition"
        >
        Akceptuję
        </button>
    </div>
    </div>
</div>
);
}